import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CloudOffIcon from '@mui/icons-material/CloudOff';
// import V3FallingItemsGame from './V3FallingItemsGame'; // Temporarily commented
import { v3Theme } from '../theme';

const V3ServerErrorScreen = () => {
    const handleTryAgain = () => {
        // Reload the page to retry connection
        window.location.reload();
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#ffffff', // White background
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingX: 3,
                paddingBottom: 3,
                fontFamily: '"JetBrains Mono", monospace',
                zIndex: 9999,
            }}
        >
            <CloudOffIcon 
                sx={{ 
                    fontSize: 80, 
                    color: v3Theme.main,
                    marginBottom: 3,
                    opacity: 0.6
                }} 
            />
            
            <Typography
                variant="h4"
                sx={{
                    color: v3Theme.main,
                    fontFamily: '"JetBrains Mono", monospace',
                    fontWeight: 700,
                    marginBottom: 2,
                    textAlign: 'center'
                }}
            >
                Oops...
            </Typography>
            
            <Typography
                variant="h6"
                sx={{
                    color: v3Theme.main,
                    fontFamily: '"JetBrains Mono", monospace',
                    fontWeight: 400,
                    marginBottom: 1,
                    textAlign: 'center',
                    opacity: 0.8
                }}
            >
                Something went wrong
            </Typography>
            
            <Typography
                variant="body1"
                sx={{
                    color: v3Theme.main,
                    fontFamily: '"JetBrains Mono", monospace',
                    marginBottom: 4,
                    textAlign: 'center',
                    maxWidth: '400px',
                    opacity: 0.7
                }}
            >
                Unable to connect to the server. Please check your internet connection and try again.
            </Typography>
            
            {/* Game Container - Temporarily commented */}
            {/* <Box sx={{ 
                width: '100%', 
                maxWidth: '600px',
                marginTop: 2,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
            }}>
                <V3FallingItemsGame />
            </Box> */}
            
            {/* Try Again Button */}
            <Button
                variant="contained"
                onClick={handleTryAgain}
                sx={{
                    backgroundColor: v3Theme.main,
                    color: '#ffffff',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    fontFamily: '"JetBrains Mono", monospace',
                    paddingX: 4,
                    paddingY: 1.5,
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: v3Theme.mainDark || '#1a2530',
                    }
                }}
            >
                Try Again
            </Button>
            
        </Box>
    );
};

export default V3ServerErrorScreen;